module.exports = __webpack_public_path__ + "static/img/hero-bg-desktop-wide.f6a90d2.jpg";